/**
 * Fix an issue in samsung mobile browsers calling ToString with a capital T
 * see: https://github.com/SamsungInternet/support/issues/56#issuecomment-412439545
 **/
if (!Function.ToString) {
  /* eslint-disable */
  Function.prototype.ToString = function () { return this.toString(); };
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');
window.axios.defaults.headers.common = {
  'X-CSRF-TOKEN': window.Laravel.csrfToken,
  'X-Requested-With': 'XMLHttpRequest'
};

require('../../../vendor/wire-elements/pro/resources/js/overlay-component.js')
